<template>
  <Modal
    v-model="_value"
    width="400"
    title="锐明设置上传间隔"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setUploadIntervalParamsRef" v-model="setUploadIntervalParams" :label-width="90">
      <!--      <FormItem prop="aisle" label="密码">-->
      <!--        <Button type="primary" @click="possworsOne" style="margin-right: 5px;">密码1</Button>-->
      <!--        <Button type="primary" @click="posswordTwo">密码2</Button>-->
      <!--        <Input v-model="setUploadIntervalParams.possword" type="password" password placeholder="请输入密码">-->
      <!--        </Input>-->
      <!--      </FormItem>-->
      <FormItem prop="aisle" label="通道">
        <Select placeholder="通道" style="width: 200px;"
                v-model="setUploadIntervalParams.aisle">
          <Option v-for="(option, index) in aisleOptions" :value="option.value" :key="option.label">{{option.label}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="driverCardNum" label="间隔时长">
        <label>ACC开：</label>
        <InputNumber v-model="setUploadIntervalParams.accOn" :min="0" size="small"
                     style="margin-left: 5px;width: 45px"></InputNumber>
        <label>ACC关：</label>
        <InputNumber v-model="setUploadIntervalParams.accOff" :min="0" size="small"
                     style="margin-left: 5px;width: 45px"></InputNumber>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

  import Vue from 'vue'
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'

  import MaintainOrderAddMaintainDeviceRecordModal
    from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

  export default {
    name: 'rmsetuploadintervalmodal',
    components: {},
    props: {
      initValue: null,
      terminalNumValue: null,
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        setUploadIntervalParams: {
          id: null,
          possword: 'admin',
          aisle: null,
          accOn: 15,
          accOff: 180,
        },

        aisleOptions: [
          {label: '通道1（两客一危）', value: '1'},
          {label: '通道4（简诚（交通局））', value: '4'},
          {label: '通道5', value: '5'},
          {label: '通道6（全国货运）', value: '6'},
        ],

      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoServ_SearchByName'
      ]),
      visibleChange(val) {
        if (val) {
          this.setUploadIntervalParams.id = this._initValue
          this.setUploadIntervalParams.aisle = null
          this.setUploadIntervalParams.accOn = 15
          this.setUploadIntervalParams.accOff = 180
          this.possworsOne()
        }
      },
      onCleanDriverCardParams() {
        this.setUploadIntervalParams.possword = 'admin'
        this.setUploadIntervalParams.aisle = null
        this.setUploadIntervalParams.accOn = 15
        this.setUploadIntervalParams.accOff = 180
      },
      SendCommand(content) {
        store.dispatch('NetCommandServ_SendCommand', {
          // params: { id: this._initValue, content: '99admin,admin,SMUI'+ this.setUploadIntervalParams.aisle +','+ this.setUploadIntervalParams.accOn +','+ this.setUploadIntervalParams.accOff +'!', urgent: false }
          params: {id: this._initValue, content: content, urgent: false}
        }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      onSendDriverCardParams() {
        if (this.setUploadIntervalParams.aisle == null) {
          this.$Message.error("请选择通道")
        }
        if (this.setUploadIntervalParams.accOn == null) {
          this.$Message.error("请输入ACC开间隔时长")
        }
        if (this.setUploadIntervalParams.accOff == null) {
          this.$Message.error("请输入ACC关间隔时长")
        }

        // console.log('99admin,admin,SMUI'+ this.setUploadIntervalParams.aisle +','+ this.setUploadIntervalParams.accOn +','+ this.setUploadIntervalParams.accOff +'!')

        this.SendCommand('99admin,admin,SMUI'+ this.setUploadIntervalParams.aisle +','+ this.setUploadIntervalParams.accOn +','+ this.setUploadIntervalParams.accOff +'!')

        setTimeout(() => {
            this.SendCommand('99admin,JC336699,SMUI'+ this.setUploadIntervalParams.aisle +','+ this.setUploadIntervalParams.accOn +','+ this.setUploadIntervalParams.accOff +'!')
          }
          , 2000)

        setTimeout(() => {
            this.SendCommand('99admin,,SMUI'+ this.setUploadIntervalParams.aisle +','+ this.setUploadIntervalParams.accOn +','+ this.setUploadIntervalParams.accOff +'!')
          }
          , 3000)

        setTimeout(() => {
            this.SendCommand('99admin,870315,SMUI'+ this.setUploadIntervalParams.aisle +','+ this.setUploadIntervalParams.accOn +','+ this.setUploadIntervalParams.accOff +'!')
          }
          , 4000)

        setTimeout(() => {
            this.SendCommand('99admin,JcBOZSJCB0,SMUI'+ this.setUploadIntervalParams.aisle +','+ this.setUploadIntervalParams.accOn +','+ this.setUploadIntervalParams.accOff +'!')
          }
          , 5000)
      },
      possworsOne() {
        this.setUploadIntervalParams.possword = 'admin'
      },
      posswordTwo() {
        this.setUploadIntervalParams.possword = 'JC336699'
      },
    },
    computed: {
      _value: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _terminalNumValue: {
        get() {
          return this.terminalNumValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
